import React from "react";
import Barcode from "react-barcode";

interface Props {
  companyName?: string;
  barcode: string;
  name: string;
  itemCode?: string;
  price?: number;
}

const WSBarcodeLabel: React.FC<Props> = ({
  companyName,
  barcode,
  name,
  itemCode,
  price
}) => {
  return (
    <div
      style={{
        width: 160,
        // border: "1px dashed #ccc",
        padding: "0px 6px 1px",
        textAlign: "center",
        fontFamily: "Arial, sans-serif",
        background: "#fff"
      }}
    >
      {/* Company */}
      {companyName && (
        <div
          style={{
            fontSize: 10,
            fontWeight: 600,
            marginBottom: 2
          }}
        >
          {companyName}
        </div>
      )}

      {/* Product Name */}
      <div
        style={{
          fontSize: 7,
          fontWeight: 600,
          marginBottom: 2,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis"
        }}
      >
        {name}
      </div>

      {/* Barcode */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Barcode
          value={barcode}
          height={18}
          width={1}
          fontSize={11}
          margin={0}
          displayValue={true}
        />
      </div>

      {/* Price */}
      {price && (
        <div
          style={{
            fontSize: 10,
            fontWeight: 700,
            marginTop: 2
          }}
        >
          ₹ {price} <span>/PC {itemCode}</span>
        </div>
      )}

      {/* {itemCode && (
        <div
          style={{
            fontSize: 8,
            color: "#444",
            marginBottom: 2
          }}
        >
          {itemCode}
        </div>
      )} */}
    </div>
  );
};

export default WSBarcodeLabel;